import Axios from 'utils/axios';

export default (mod = { actions: {} }) => {
    let base = {
        namespaced: true,
        state: {
            list: [],
            page: 1,
            pageSize: 10,
            total: 0,
            condition: {},
        },
        getters: {},
        mutations: {
            complete(state, payload) {
                Object.assign(state, payload);
            },
            update(state, payload) {
                Object.assign(state, payload);
            }
        },
        actions: {}
    };

    if (mod.actions) {
        for (let key in mod.actions) {
            base.actions[key] = mod.actions[key];
        }

        if (typeof mod.actions.fetch === 'string') {
            base.actions.fetch = ({ commit, state }, payload) => {
                return Axios.get(mod.actions.fetch, {
                    params: {
                        pageSize: state.pageSize,
                        page: state.page,
                        ...payload,
                        ...state.condition,
                    }
                }).then(function(res) {
                    commit('complete', {
                        list: (res && res.list) || [],
                        total: (res && res.total) || 0
                    });
                });
            };
        }

        if (typeof mod.actions.fetchMore) {
            base.actions.fetchMore = ({ commit, state }, payload) => {
                return Axios.get(mod.actions.fetchMore, {
                    params: {
                        page: state.page,
                        pageSize: state.pageSize,
                        ...payload,
                        ...state.condition,
                    }
                }).then(res => {
                    commit('update', {
                        list: state.list.concat(res.list || []),
                        total: res.total || 0
                    });
                });
            };
        }

        if (typeof mod.actions.save === 'string') {
            base.actions.save = ({ commit }, payload) => {
                return Axios.post(mod.actions.save, payload);
            };
        }

        if (typeof mod.actions.delete === 'string') {
            base.actions.delete = ({ commit }, payload) => {
                return Axios.post(mod.actions.delete, payload);
            };
        }
    }

    Object.assign(base.state, mod.state);
    Object.assign(base.mutations, mod.mutations);
    Object.assign(base.getters, mod.getters);
    return base;
};
